import { createRouter } from "@tanstack/react-router";

import { ErrorPage } from "~/components/ErrorPage";
import { routeTree } from "~/routeTree.gen";

// The single router instance for the app. `routeTree.gen.ts` is
// generated by @tanstack/router-plugin/vite from everything under
// src/routes/ and is deliberately gitignored — it rebuilds on every
// dev/build run.
export const router = createRouter({
  routeTree,
  // Default preload behavior: follow links on hover to warm up the
  // route's loader. Cheap latency win that's easy to undo later if
  // it causes problems.
  defaultPreload: "intent",
  // Any route error nothing more specific catches lands here instead of
  // TanStack Router's built-in raw error screen (TMF-169): a friendly page
  // with a way home, or a redirect to /login for a session that expired
  // after the page had already loaded.
  defaultErrorComponent: ErrorPage,
});

// Type-safe router augmentation — this tells @tanstack/react-router's
// internal types about our specific router instance so Link, useParams,
// useNavigate, etc. all autocomplete and type-check against our actual
// route tree.
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
